import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/system";

export default function CarrierNetworkActionBase({ 
  backgroundColor, 
  canAddAsLead,
  canAddManually,
  canUpdate,
  onClick,
  isOpen,
  ...props 
}) {
  return (
    <Box 
      sx={{ 
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0 12px",
        borderRadius: "20px",
        backgroundColor: backgroundColor,
        color: "white_opacity.100",
        maxWidth: "fit-content",
        ...((isOpen && !canAddAsLead && !canAddManually) && { opacity: ".5"}),
        ...((canAddManually || canAddAsLead || canUpdate) && { "&:hover": { cursor: "pointer" } }) 
      }}
      onClick={onClick}
    > 
      {props.children}
    </Box>
  );
}

CarrierNetworkActionBase.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  canAddAsLead: PropTypes.bool,
  canAddManually: PropTypes.bool,
  canUpdate: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.node
};